import { Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class VehicleInfoContextState {
	readonly operatorUuid = signal<string | null>(null)
}
